import { revokeRefreshToken } from '../../../../shared/api';
import { apiClient, LOGIN, LOGOUT } from '../../../shared/api';

export const login = async ({ email, password }) => {
  const requestBody = {
    user: {
      email,
      password,
    },
  };

  return apiClient.post(LOGIN, requestBody);
};

export const logout = async () => {
  // Denylist the access token and sever WebSocket connections.
  await apiClient.delete(LOGOUT);

  // Revoke the refresh token family and delete the refresh cookie.
  await revokeRefreshToken();
};
